import { render, staticRenderFns } from "./type10.vue?vue&type=template&id=535653a4&scoped=true&"
import script from "./type10.vue?vue&type=script&lang=js&"
export * from "./type10.vue?vue&type=script&lang=js&"
import style0 from "./type10.vue?vue&type=style&index=0&id=535653a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535653a4",
  null
  
)

export default component.exports